(function () {
  if (window.b4lAmazonAffiliateTrackingInitialized) return;
  window.b4lAmazonAffiliateTrackingInitialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', 'G-QT7BLF275Z', { send_page_view: false });

  if (!document.querySelector('script[data-b4l-ga4-events]')) {
    var ga = document.createElement('script');
    ga.async = true;
    ga.src = 'https://www.googletagmanager.com/gtag/js?id=G-QT7BLF275Z';
    ga.setAttribute('data-b4l-ga4-events', 'true');
    document.head.appendChild(ga);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    var host = (link.hostname || '').toLowerCase();
    if (host !== 'amzn.to' && host.indexOf('amazon.') === -1) return;

    var destination = link.href || '';
    var linkText = (link.textContent || link.getAttribute('aria-label') || 'Amazon link')
      .trim().replace(/\s+/g, ' ').slice(0, 100);
    var spreadrId = (link.id || '').replace('SpreadrLink-', '');
    var spreadrData = spreadrId ? document.getElementById('SpreadrHidden-' + spreadrId) : null;
    var productTitle = spreadrData ? spreadrData.getAttribute('data-title') : '';
    var productId = spreadrData ? spreadrData.getAttribute('data-product') : '';
    var pageType = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page)
      ? window.ShopifyAnalytics.meta.page.pageType : '';

    window.gtag('event', 'amazon_affiliate_click', {
      send_to: 'G-QT7BLF275Z',
      link_url: destination,
      link_text: linkText,
      outbound: true,
      affiliate_product_title: productTitle || document.title,
      affiliate_product_id: String(productId || ''),
      affiliate_destination: destination,
      affiliate_button_text: linkText,
      affiliate_page_type: pageType,
      transport_type: 'beacon'
    });
  }, true);
})();